import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Form, Input, Row, Col } from "reactstrap";
import Switch from 'react-switch';
import MaterialTable from 'material-table';

// style
import { table_translate, table_style } from "../../../../constants/MaterialTable.js";

export default function FormularioFichaQuestoesModalResposta({ isOpen, isDisable, formularioVistoriaQuestao_Id, formularioVistoriaQuestaoOpcoes, handleReturn }) {

    const { register, errors, handleSubmit, setValue } = useForm({ mode: "onBlur" });

    const [considerarPenalidade, set_considerarPenalidade] = useState(false);
    const handleChangeConsiderarPenalidade = value => {
        set_considerarPenalidade(value);
    }

    const [list_table, set_list_table] = useState([]);

    const [rowEdit, set_rowEdit] = useState(null);
    const handleEdit = (rowData) => {
        set_rowEdit(rowData);
        setValue("valor", rowData.valor);
        setValue("pesoIQG", rowData.pesoIQG);
        set_considerarPenalidade(rowData.considerarPenalidade);
    }

    const loadForm = () => {
        if (isOpen)
            set_list_table(formularioVistoriaQuestaoOpcoes ? formularioVistoriaQuestaoOpcoes : []);
    }

    useEffect(() => {
        loadForm();
    }, [isOpen]);

    const onSubmit = (data) => {
        let json_submit = {
            formularioVistoriaQuestaoOpcao_Id: rowEdit ? rowEdit.formularioVistoriaQuestaoOpcao_Id : 0,
            formularioVistoriaQuestao_Id: formularioVistoriaQuestao_Id,
            valor: data.valor,
            pesoIQG: data.pesoIQG,
            considerarPenalidade: considerarPenalidade
        }

        let _list = list_table.filter(f => f != rowEdit);
        _list.push(json_submit);
        set_list_table(_list);

        set_rowEdit(null);
        setValue("valor", "");
        setValue("pesoIQG", "");
        set_considerarPenalidade(false);
    }

    const CloseModal = () => {
        handleReturn(list_table);
    }

    return (
        <>
            <Modal isOpen={isOpen} toggle={CloseModal} size="lg">
                <ModalHeader toggle={CloseModal}>Opções de Resposta da Questão</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <label className="form-control-label">Resposta</label>
                                    <Input className="form-control"
                                        autocomplete="off"
                                        type="text"
                                        name="valor"
                                        innerRef={register({ required: true })}
                                        disabled={isDisable}
                                    />
                                    {errors.valor && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <label className="form-control-label">Peso IQG</label>
                                    <Input className="form-control"
                                        autocomplete="off"
                                        type="number"
                                        name="pesoIQG"
                                        innerRef={register({ required: false })}
                                        disabled={isDisable}
                                    />
                                    {errors.pesoIQG && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <label htmlFor="considerarPenalidade">
                                        <span>Considerar como penalidade</span><br />
                                        <Switch name="considerarPenalidade"
                                            id="considerarPenalidade"
                                            className="react-switch"
                                            checked={considerarPenalidade}
                                            onChange={handleChangeConsiderarPenalidade}
                                            onColor="#86d3ff"
                                            onHandleColor="#2693e6"
                                            disabled={isDisable}
                                        />
                                    </label>
                                </FormGroup>
                            </Col>
                        </Row>
                        {!isDisable &&
                            <Row>
                                <Col md="12" className="text-center">
                                    <Button color="success" type="submit">
                                        <i className="fas fa-plus"></i> Adicionar
                                    </Button>
                                </Col>
                            </Row>
                        }
                        <Row>
                            <Col lg="12">
                                <MaterialTable style={{ minHeight: "auto" }}
                                    title="Lista de Respostas"
                                    columns={[
                                        { title: 'Resposta', field: 'valor' },
                                        { title: 'Peso IQG', field: 'pesoIQG' },
                                        { title: 'Considerar como penalidade', render: (rowData) => rowData.considerarPenalidade ? "Sim" : "Não" }
                                    ]}
                                    data={list_table}
                                    isLoading={false}
                                    options={{
                                        ...table_style,
                                        filtering: false,
                                        exportButton: true
                                    }}
                                    actions={[
                                        {
                                            icon: 'edit',
                                            tooltip: 'Editar Registro',
                                            onClick: (event, rowData) => handleEdit(rowData)
                                        }
                                    ]}
                                    localization={table_translate}
                                />
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
                <ModalFooter className="text-right">
                    <Button color="default" onClick={CloseModal}>
                        Fechar
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
}

